import React from 'react';

class CompleteProfileHeader extends React.Component {

    render () {
        return (
            <header className="create-shift-header">
                <div className="maxwidth-wrapper">
                    <div className="left">
                        <h1 className="page-title">Complete profile</h1>
                    </div>
                </div>
            </header>
        );
    }
}

export default CompleteProfileHeader;



/** WEBPACK FOOTER **
 ** ./app/src/components/CompleteProfileHeader.js
 **/